<div class="users flex flex-col justify-between h-full">
	<div class="h-full">
		<app-table-users
			[heigthTable]="347"
			[pagination]="pagination"
			[userTable]="userTable"
			[group]="group"
			[columnsFilter]="columns"
			[loading]="loading"
		>
		</app-table-users>
	</div>
	<div class="buttons flex items-center justify-end h-16 pr-4">
		<button class="mg-button px-3" (click)="openDialogUser()">
			<mat-icon class="text-primary-color mr-2"> add </mat-icon>
			<span class="font-lato"> {{ translateUser.buttonNew }} </span>
		</button>
	</div>
</div>
